import { BaseModel, type RelationConfig } from './base';
import { Employee } from './employee';

import type { Permissions } from '../types/interfaces/permissions';

export class ResourceType extends BaseModel {
  id!: number;
  idResourceType!: number;
  name!: string;
  deleted!: number;
  created!: number;
  modified!: number;
  permissions!: Permissions;

  resources?: Employee[];

  static override relations(): RelationConfig {
    return {
      resources: { type: Employee },
    };
  }

  override objectID(): string {
    return this.idResourceType?.toString() || '';
  }
} 